<template>
    <div class="beachBallContainer" :id="id">
        <div class="loader"/>
    </div>
</template>

<script>
export default {
    name: 'MuffinLoader',
    components: {},
    data: function() {
        return {
            // value: null
        };
    },
    props: {
        id: {
            type: String,
            default: 'prozisLoader',
        },
        lockScroll: false,
    },
    watch: {},
    created() {
    },
    mounted() {
       /* if (this.lockScroll === true) {
            document.body.style.top = `-${window.scrollY}px`;
            document.body.style.position = 'fixed';
        }*/
    },
    destroyed() {
       /* if (this.lockScroll === true) {
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            window.scrollTo(0, (parseInt(scrollY || '0')) * -1);
        }*/
    },
};
</script>

<style lang="scss">
    @import "../../../../../prozis/src-nodejs/scss/common/components/beachBall.scss";
</style>
